import { render } from "./Admin_Ordenes.vue?vue&type=template&id=d407841c"
import script from "./Admin_Ordenes.vue?vue&type=script&lang=js"
export * from "./Admin_Ordenes.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__